import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import { runInAction } from 'mobx';
import React, { useState } from 'react';
import styled from 'styled-components';

import SpinningLoading from '../SpinningLoading';

const SocialProfileRefreshOverlay = () => {
  const videoCreator = useVideoCreatorStore();
  const storyId = videoCreator.storyId;
  const [loading, setLoading] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  async function refreshStory() {
    // update story in store, so that the new profile is added to the list
    if (storyId) {
      const originallyLoading = loading;
      if (!originallyLoading) {
        setLoading(true);
      }
      const story = await videoCreator.findOneStory(storyId);

      if (story) {
        videoCreator.story = story;
      }

      if (!originallyLoading) {
        setLoading(false);
      }

      runInAction(() => {
        videoCreator.showRefreshStoryForSocialProfile = false;
      });
    }
  }

  if (!videoCreator.showRefreshStoryForSocialProfile) return null;

  return (
    <RefreshOverlay>
      {loading && (
        <SpinningLoading
          customStyle={{
            top: 0,
            position: 'fixed',
            alignItems: 'center',
          }}
          text="Refreshing..."
        />
      )}
      <Heading>When your account has been linked</Heading>
      <SubHeading>Please refresh the page</SubHeading>
      {/*
        <Button onClick={refreshStory}>
            <LinkIcon /> Refresh link
        </Button> */}
    </RefreshOverlay>
  );
};

export default SocialProfileRefreshOverlay;

const RefreshOverlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: var(--overlay-dark);
  top: 0;
  left: 0;
  z-index: 11;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Heading = styled.span`
  font-weight: var(--font-weight-bold);
  font-size: 32px;
  line-height: 38.73px;
  color: var(--text-secondary);
`;

const SubHeading = styled.span`
  font-weight: var(--font-weight-normal);
  font-size: var(--text-sm);
  line-height: 19.6px;
  color: var(--text-secondary);
  margin-top: 5px;
  margin-bottom: 30px;
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
const Button = styled.button<{
  borderColor?: string;
  color?: string;
  backgroundColor?: string;
  width?: string;
}>`
  display: flex;
  width: 240px;
  height: var(--btn-h-xl);
  padding: var(--btn-px-lg);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-sm);
  border-radius: var(--radius-button);
  cursor: pointer;
  border: none;
  background-color: var(--primary);
  color: var(--background);
  font-weight: var(--font-weight-bold);
  font-size: var(--text-sm);
  line-height: 16.94px;
  color: var(--background);
`;
